// Section.jsx
import React from 'react';
import PropTypes from 'prop-types';

const Section = ({ title, children, id }) => (
  <div className="lndad-section" id={id}>
    <h2 className="lndad-section-title">{title}</h2>
    {children}
  </div>
);

Section.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  id: PropTypes.string,
};

export default Section;
